
export default function SaveButton({ onClick, style }){
    return(
        <div className="save-button" style={style}>
            <button className="save" onClick={onClick}>
                SAVE
            </button>
        </div>
    )
}


export function RemoveButton(){
    return(
        <div className="remove-button" style={{margin:'20px'}}>
            <button className="remove">
                REMOVE
            </button>
        </div>
    )
}